export const intervals = [
    "MONTHLY",
    "QUARTERLY",
    "SEMIANNUAL",
    "ANNUAL"
];